export default "__VITE_ASSET__lLHQJtU9__"